import React from "react";

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  // 直接返回children，让页面自己处理布局
  return <>{children}</>;
};

export default AuthLayout;
